import React from "react"
import { DataTable } from "home/components/data_table"

const PerformanceTablePresentation = ({ tableData, resource, hasFilters }) => (
  <DataTable tableData={tableData} resource={resource} hasFilters={hasFilters} tableSize="big" />
)

export default PerformanceTablePresentation
